import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { APIResponse } from "src/app/core/models/api-response";
import { ICategory } from "../models/categories.models";
import { environment } from "src/environments/environment";
import { IPageCount } from "src/app/shared/models/page.model";

@Injectable({
  providedIn: 'root',
})
export class CategoriesService {

  constructor(private http: HttpClient) { }

  public listAllCategories(includes?: Array<string>): Observable<APIResponse<ICategory>> {
    let params = new HttpParams();
    if (includes) {
      params = params.set('includes', includes.join(','));
    }
    return this.http.get<APIResponse<ICategory>>(`${environment.BASE_URL_API}categories`, { params });
  }

    public listCategories(page: IPageCount, key?: string): Observable<APIResponse<ICategory>> {
      const params = new HttpParams()
            .set('page', page.number)
            .set('limit', page.size)
            .set('key', key!);
      return this.http.get<APIResponse<ICategory>>(environment.BASE_URL_API + 'categories', { params });
    }

    public addCategory(category: Omit<ICategory, 'id'> ): Observable<APIResponse<ICategory>> {
      return this.http.post<APIResponse<ICategory>>(
        environment.BASE_URL_API + 'category',
        category
      );
    }

    public updateCategory(id: number, category: Omit<ICategory, 'id'> ): Observable<APIResponse<ICategory>> {
      return this.http.post<APIResponse<ICategory>>(
        environment.BASE_URL_API + 'category/' + id,
        category
      );
    }

    public deleteCategory(id: number): Observable<APIResponse<ICategory>> {
      return this.http.delete<APIResponse<ICategory>>(
        environment.BASE_URL_API + 'category/' + id,
      );
    }
  }
